import Config from '../definitions/Config';


const API_ENDPOINT = `${Config.PROFILE_BFF_URL}/mortgage-applied`;

/**
 *
 * @param {string} email
 * @returns {Promise<*>}
 */
async function fetchHasMortgageApplications(email) {
    if (!email) {
        throw new Error(`Email is required to confirm previous mortgages. received: ${email}`);
    }

    const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
        credentials: 'include',
    });

    let responseBody;
    try {
        responseBody = await response.json();
    } catch (e) {
        throw new Error(`Unknown mortgage check failure. Status code: ${response.status}`);
    }

    if (response.ok) {
        return responseBody.data;
    } else {
        throw responseBody;
    }
}

export {
    fetchHasMortgageApplications,
    API_ENDPOINT,
};
